import { defineFcm } from '../shared/factory';

export const FCM_OPTIMIZELY_ENABLED = defineFcm('optimizely_enabled').asBoolean().withDefault(false).toConfig({
	owner: 'squad-site-platform',
	scope: 'corgi-front-end',
	context: 'Optimizely experiments',
	description: 'Used to toggle Optimizely on the platform',
});
